<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	<div [innerHTML]="message"></div>
</mat-dialog-content>

<mat-dialog-actions >
	<div class="w-100 mt-3 p-2 justify-end items-center flex-row">
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
	</div>
</mat-dialog-actions>
